import { mapGetters } from 'vuex';

// @vue/component
export default {
  name: 'onboarding-layout',

  computed: {
    pictureCssClass() {
      if (
        [
          'onboarding-forgot-password',
          'onboarding-reset-password',
          'onboarding-coaching-options',
          'onboarding-business-setup',
        ].includes(this.$route.name)
      ) {
        return 'theme-man';
      } else {
        return 'theme-woman';
      }
    },

    ...mapGetters('color_scheme', ['siteLogo']),
  },
};
